import {
  OPEN_QUALITY_PICKER,
  CLOSE_QUALITY_PICKER,
} from 'actiontypes/qualityPicker';

const INITIAL_STATE = {
  isOpen: false,
  nature: undefined,
};

export default function reducer(state = INITIAL_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case OPEN_QUALITY_PICKER:
      return {
        ...state,
        isOpen: true,
        nature: payload.nature,
      };
    case CLOSE_QUALITY_PICKER:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}